var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aggregate-contents-item",class:{
    first: _vm.itemOnTop,
    small: _vm.small,
  }},[_c('div',{staticClass:"index"},[_vm._v(" "+_vm._s(_vm.index)+". ")]),_c('p',{staticClass:"serial-number"},[_vm._v(" "+_vm._s(_vm.serialNumber)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }